import React,{forwardRef} from 'react'
import FinalSetupForm from './FinalSetupForm'

const AddFinalSetup = forwardRef((props, ref) => {
    const {
        othersFormSave,
        othersFormUpdateState,
        formValidateError,
        formData,
        isButtonLoader
    } = props;
    return (
        <>
            <FinalSetupForm
                othersFormSave={othersFormSave}
                othersFormUpdateState={othersFormUpdateState}
                formValidateError={formValidateError}
                formActionType={'insert'}
                formData={formData}
                isInfoOpenHandler={props.isInfoOpenHandler}
                ref={ref}
                isButtonLoader={isButtonLoader}
            />
        </>
    )
})

export default AddFinalSetup